import * as React from "react";
const SvgGallery = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M16.5 4.5h-9v7h9v-7ZM9 10V6h6v4H9Z" fill="currentColor" />
    <path
      d="M5 3.75C5 2.784 5.784 2 6.75 2h10.5c.967 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 17.25 14H6.75A1.75 1.75 0 0 1 5 12.25v-8.5Zm1.75-.25a.25.25 0 0 0-.25.25v8.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-8.5a.25.25 0 0 0-.25-.25H6.75ZM6.48 15.864l-.267-.204a.751.751 0 0 0-.926 0c-.122.092-.24.186-.357.28-.574.459-1.158.925-2.367 1.237a.75.75 0 0 0 .375 1.453A7.02 7.02 0 0 0 5 17.75v2.75A.75.75 0 0 0 5 22h1.5a.75.75 0 0 0 0-1.5v-2.78c.276.171.59.343.95.5 1.05.455 2.467.78 4.543.78 2.083 0 3.503-.325 4.554-.78.362-.157.677-.329.953-.5v2.78a.75.75 0 0 0 0 1.5H19a.75.75 0 0 0 0-1.5v-2.765c.513.324 1.17.647 2.058.882a.75.75 0 0 0 .384-1.45c-1.216-.322-1.83-.805-2.418-1.266-.103-.081-.206-.162-.31-.24a.741.741 0 0 0-.464-.161.746.746 0 0 0-.463.16l-.266.204c-.438.338-.88.68-1.57.979-.825.357-2.034.657-3.958.657-1.916 0-3.122-.3-3.945-.657-.688-.298-1.13-.64-1.568-.979Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgGallery;
